class PipContainerElement extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this);
  }

  handleEvent(e) {
    if (e.type === "click") {
      const targetEl = e.target.closest("img, video-player");
      if (!targetEl) return;
      const mediaEl = targetEl.querySelector("video") ?? targetEl;

      const mediaBounds = mediaEl.getBoundingClientRect();

      const fromTop = mediaBounds.top;
      const fromRight = window.innerWidth - mediaBounds.right;
      const fromBottom = window.innerHeight - mediaBounds.bottom;
      const fromLeft = mediaBounds.left;

      const fromInset = `${fromTop}px ${fromRight}px ${fromBottom}px ${fromLeft}px`;

      const fromWidth = `${mediaBounds.width}px`;
      const fromHeight = `${mediaBounds.height}px`;

      const popover = this._popover = document.createElement("div")
      popover.className = "lightbox";
      popover.toggleAttribute("popover", true);

      const clone = targetEl.cloneNode(true);
      popover.append(clone);

      const aspect = `${mediaEl.naturalWidth || mediaEl.width} / ${mediaEl.naturalHeight || mediaEl.height}`;

      popover.style.setProperty("--aspect", aspect);

      this.style.display = "none";

      document.body.append(popover);
      popover.showPopover();

      const toRect = popover.getBoundingClientRect();

      const toInset = "0";
      const toWidth = `${toRect.width}px`;
      const toHeight = `${toRect.height}px`;

      popover.style.setProperty("--from-inset", fromInset);
      popover.style.setProperty("--from-width", fromWidth);
      popover.style.setProperty("--from-height", fromHeight);

      popover.style.setProperty("--to-inset", toInset);
      popover.style.setProperty("--to-width", toWidth);
      popover.style.setProperty("--to-height", toHeight);

      popover.animate(
        {
          inset: [fromInset, toInset],
          width: [fromWidth, toWidth],
          height: [fromHeight, toHeight],
        },
        { duration: 300, easing: "ease" },
      );

      popover.addEventListener("beforetoggle", this);

      clone.addEventListener("click", () => {
        popover.hidePopover();
      });
    } else if (e.type === "beforetoggle") {
      if (e.newState === "closed") {
        this._popover.classList.add("transition");
        this._popover.getBoundingClientRect(); // Force a style recalc.
        this._popover.addEventListener("transitionend", () => {
          this.style.display = "";
          this._popover.remove();
          this._popover = null;
        }, { once: true });
      }
    }
  }
}

customElements.define("pip-container", PipContainerElement);
